import { render, staticRenderFns } from "./my-favorites.vue?vue&type=template&id=ef98100a"
import script from "./my-favorites.vue?vue&type=script&lang=js"
export * from "./my-favorites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoadMore: require('/vercel/path0/components/ui/loadMore.vue').default,EmptyState: require('/vercel/path0/components/ui/emptyState.vue').default})
